export default __webpack_public_path__ + "static/junk-removal-e589f6f1a9850c335d1968c8c985b088.jpg";